export default
{
    "status": 0,
    "data": {
        "CP_CD": "0801",
        "STORE_CD": "0001",
        "TNANT_CD": "0002",
        "SHOP_ID": "0003626",
        "POS_NO": "0001",
        "IS_SIMPLE_TOKEN": "N"
    },
    "message": ""
}